import { fetchLookups, fetchAllLookups } from '@/service/engagement.js';

const state = {
    lookups: {},
    allLookups: {}
}
const mutations = {
    SET_LOOKUPS(state, lookups) {
        state.lookups = lookups
    },
    SET_ALL_LOOKUPS(state, allLookups) {
        state.allLookups = allLookups
    }
}
const actions = {
    async fetchLookups({ commit }) {
        try {
            const lookups = await fetchLookups();
            commit('SET_LOOKUPS', lookups);
        } catch (error) {
            console.error('Error fetching lookups:', error);
        }
    },
    async fetchAllLookups({ commit }) {
        try {
            const allLookups = await fetchAllLookups();
            commit('SET_ALL_LOOKUPS', allLookups);
        } catch (error) {
            console.error('Error fetching all lookups:', error);
        }
    }
}
const getters = {
    lookups: state => state.lookups,
    getAllLookups: state => state.allLookups,
    getLookupByType: (state) => (type) => {
        return state.lookups[type] || [];
    },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}